export default "__VITE_ASSET__Ct2kx4px__"